export function createEmptyWorkspaceSettings() {
    return {
        name: "",
        address: "",
        siren: "",
        siret: "",
        rna: "",
        signatoryFunction: "",
        signatoryName: "",
        receiptObject: "",
        organizationQualification: "",
        signatureUrl: null,
    };
}
